export enum BackupServices {
    Databases = 'databases',
    Tablesdb = 'tablesdb',
    Documentsdb = 'documentsdb',
    Vectorsdb = 'vectorsdb',
    DedicatedDatabases = 'dedicatedDatabases',
    Functions = 'functions',
    Storage = 'storage',
}
